module.exports = __webpack_public_path__ + "img/review_banner.1b6b824c.png";